import "./tailwind.css";
import "./assets/styles/global.scss";

import { CssBaseline, ThemeProvider } from "@mui/material";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import App from "./App";
import theme from "./assets/styles/theme";
import store from "./services/store";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />

            <Provider store={store}>
                <BrowserRouter>
                    <Routes>
                        <Route path='/*' element={<App />} />
                    </Routes>
                </BrowserRouter>
            </Provider>
        </ThemeProvider>
    </React.StrictMode>
);
